import stateOptions from "./stateOptions";
var getDefaultStateOption = function (value) {
    return (stateOptions.find(function (stateOption) { return stateOption.value === value; }) ||
        stateOptions[0]);
};
export default getDefaultStateOption;
